import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { mapsAPI } from "../store/slices/mapsSlice";
import EventsTimeLine from "./EventsTimeLine";
import {
  useGetEventQuery,
  useUpdateEventStatusMutation,
} from "../store/slices/settingsSlice";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export function EventDetailsTable({ eventUuid }: { eventUuid: string }) {
  const { data: event } = useGetEventQuery(eventUuid);
  const [setEventStatus] = useUpdateEventStatusMutation();
  const dispatch = useDispatch();
  const confirmDialog = useConfirmDialog();
  const closeEvent = async (uuid: string) => {
    if (
      !(await confirmDialog(
        "Close Event",
        "Are you sure you want to close this event?"
      ))
    ) {
      return;
    }
    setEventStatus({ uuid, status: "closed" });
    dispatch(mapsAPI.util.invalidateTags(["Locations"]));
  };

  return (
    event && (
      <table className="table">
        <tr>
          <th>Reference</th>
          <td className="text-end ps-2 bg-transparent">
            <div
              className="bg-transparent"
              onClick={(e) => e.stopPropagation()}
            >
              {/* <EventsTimeLine eventData={event} /> */}
            </div>
          </td>
        </tr>
        <tr>
          <th>Label</th>
          <td className="text-end ps-2">{event.Label}</td>
        </tr>
        <tr>
          <th>Description</th>
          <td className="text-end ps-2">{event.Description}</td>
        </tr>
        <tr>
          <th>Ticket</th>
          <td className="text-end ps-2">
            {event.Ticket ? (
              <Link
                to={"/reporting/ticketing/data"}
                state={{ ticket: event.Ticket }}
                className="bg-transparent p-0"
              >
                {event.Ticket}
              </Link>
            ) : (
              "-"
            )}
          </td>
        </tr>
        <tr>
          <th>Status</th>
          <td className="text-end ps-2">
            {" "}
            <span
              className={`badge rounded-pill text-white fw-bold py-1 ${
                event.Status === "active"
                  ? "bg-danger"
                  : event.Status === "closed"
                  ? "bg-secondary"
                  : event.Status === "resolved"
                  ? "bg-success"
                  : event.Status === "creating"
                  ? "bg-warning"
                  : ""
              }`}
            >
              {event.Status}
            </span>
          </td>
        </tr>
        <tr>
          <th>Severity</th>
          <td className="text-end ps-2">
            <span
              className="badge rounded-pill text-white fw-bold py-1"
              style={{
                backgroundColor:
                  event.Severity === "critical"
                    ? "red"
                    : event.Severity === "high"
                    ? "orange"
                    : event.Severity === "medium"
                    ? "gold"
                    : "seagreen",
              }}
            >
              {event.Severity}
            </span>
          </td>
        </tr>
        <tr>
          <th>Started At</th>
          <td className="text-end ps-2">
            {event.StartAt ? new Date(event.StartAt).toLocaleString() : "-"}
          </td>
        </tr>
        {event.Status !== "active" ? (
          <tr>
            <th>End At</th>
            <td className="text-end ps-2">
              {event.EndAt && event.EndAt.Valid
                ? new Date(event.EndAt.Time).toLocaleString()
                : "-"}
            </td>
          </tr>
        ) : null}
        <tr>
          <td colSpan={2}>
            <EventsTimeLine eventUuid={event.Uuid} label={"Event details"} />
          </td>
        </tr>
      </table>
    )
  );
}

export default function EventModal({
  uuid,
  children,
  className,
}: {
  uuid: string;
  children: React.ReactNode;
  className?: string;
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        type="button"
        variant="link"
        className="p-0"
        onClick={handleShow}
        title="View Event Details"
      >
        {children}
      </Button>

      <Modal show={show} onHide={handleClose} className={className}>
        <Modal.Header closeButton>
          <Modal.Title>Event details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EventDetailsTable eventUuid={uuid} />
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
